import { client } from "./client";

// 서버 시작 시 읽어둔 web-config.json 전체
export const getWebConfigAll = async () => {
  const response = await client.get("/config-all");
  return response.data.config as Record<string, any>;
};

// 변경된 항목만 보내면 서버가 web-config.json 에 병합 저장 (관리자 전용)
export const patchWebConfig = async (patch: Record<string, any>) => {
  const response = await client.patch("/config", patch);
  return response.data.config as Record<string, any>;
};

let cache: Record<string, any> = {};

export const loadWebConfig = async () => {
  cache = await client
    .get("/config-all", { timeout: 3000 })
    .then((r) => r.data.config as Record<string, any>)
    .catch(() => ({}));
};

export const feature = (path: string) => path.split(".").reduce<any>((o, k) => o?.[k], cache) !== false;
